export default __webpack_public_path__ + "static/media/img-success.eb8bc812.svg";